import { useNavigationStore } from 'store';
import { Button, Stack, CircularProgress } from '@mui/material';
import { TeleportGroupType } from './NavigationWrapper';

export const AnimatedTeleportButton = ({
  progressValue,
  endTpType,
  isTpUp,
}: {
  progressValue?: number;
  endTpType?: TeleportGroupType;
  isTpUp?: boolean;
}) => {
  return (
    <Stack
      sx={{
        width: '142.143px',
        height: '142.143px',
        position: 'relative',

        '@keyframes fadeInOut': {
          '0%': { opacity: 1 },
          '50%': { opacity: 0 },
          '100%': { opacity: 1 },
        },
      }}
      alignItems="center"
    >
      {endTpType === TeleportGroupType.Elevator ? (
        <>
          <img
            src="/navigation/teleport-vector-1.svg"
            alt="nothing"
            style={{
              animation: 'fadeInOut 2s infinite',
              transform: isTpUp ? 'none' : 'rotate(180deg)',
            }}
          />
          <img
            src="/navigation/teleport-vector-2.svg"
            alt="nothing"
            style={{
              animation: 'fadeInOut 2s infinite',
              animationDelay: '1s',
              transform: isTpUp ? 'none' : 'rotate(180deg)',
            }}
          />
        </>
      ) : (
        <Stack
          sx={{
            width: '130px',
            height: '130px',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'white',
            position: 'absolute',
            top: '-30px',
            borderRadius: '50%',
          }}
        >
          <img src="/navigation/stairway_icon.png" alt="nothing" />
        </Stack>
      )}
      <CircularProgress
        variant="determinate"
        size={142}
        value={progressValue}
        sx={{
          position: 'absolute',
          zIndex: 2,
          top: -35,
        }}
      />
      {/* fixed background */}
      <CircularProgress
        variant="determinate"
        size={142}
        value={100}
        sx={{
          position: 'absolute',
          color: '#E4EAFF',
          zIndex: 1,
          top: -35,
        }}
      />
    </Stack>
  );
};

export const TeleportButton = ({ rtl }: { rtl?: boolean }) => {
  const translation = useNavigationStore((state) => state.navigationTranslation);

  return (
    <Stack
      sx={{
        width: '245.196px',
        height: '280.731px',
        borderRadius: '37.312px',
        background: '#FFF',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <AnimatedTeleportButton />
      <Stack
        sx={{
          width: '100%',
          height: '75.226px',
          padding: '17.768px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '17.768px',
          flexShrink: 0,
          borderRadius: '0px 0px 35.536px 35.536px',
          background: '#F4F4F4',
        }}
      >
        <Button
          sx={{
            borderRadius: '27.355px',
            background: '#2055FF',
            height: '51.974px',
            width: '100%',
          }}
        >
          {translation?.navClickOnEnter || 'Click to enter'}
        </Button>
      </Stack>
      <img
        width="48"
        height="40"
        src="/navigation/teleport-button-bottom.svg"
        alt="nothing"
        style={{
          position: 'absolute',
          bottom: '-25px',
          left: 0,
          right: 0,
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      />
    </Stack>
  );
};
